import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLogin } from '@/api/queries';
import { ApiError } from '@/api/client';

/**
 * `next` smí být jen cesta na našem originu. Absolutní URL ani `//host` se
 * nepřijímá — jinak by z přihlašovací stránky byl open redirect.
 */
export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return '/';
  return raw;
}

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = safeNext(searchParams.get('next'));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login.mutateAsync({ email, password });
      // `/oauth/*` renderuje backend (souhlasová stránka OAuth), ne router —
      // přes navigate() by uživatel skončil na 404 v SPA.
      if (next.startsWith('/oauth/')) {
        window.location.assign(next);
      } else {
        navigate(next, { replace: true });
      }
    } catch {
      /* chyba se zobrazí níže z login.error */
    }
  };

  const message =
    login.error instanceof ApiError
      ? login.error.message
      : login.error
        ? 'Přihlášení selhalo. Zkus to znovu.'
        : null;

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-card__brand">
          <span aria-hidden="true">◧</span> StickyIQ
        </div>
        <p className="login-card__sub">Analytika sticky reklamních pozic</p>

        <label className="field">
          <span>E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>

        <label className="field">
          <span>Heslo</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {message ? (
          <p className="login-card__error" role="alert">
            {message}
          </p>
        ) : null}

        <button type="submit" className="btn btn--primary btn--block" disabled={login.isPending}>
          {login.isPending ? 'Přihlašuji…' : 'Přihlásit se'}
        </button>

        <p className="login-card__note">
          Interní aplikace R2B2. Přístup zřizuje správce.
        </p>
      </form>
    </div>
  );
}
